import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { StorageService } from '../../core/services/storage.service';


@Component({
  selector: 'app-language-modal',
  templateUrl: './language-modal.component.html',
  styleUrls: ['./language-modal.component.css']
})
export class LanguageModalComponent implements OnInit {
  
  isChecker!: boolean;
  class: any;
  constructor(private modalService: BsModalService, private route: Router, public modalRef: BsModalRef,
    private storageService: StorageService) { }

  ngOnInit(): void {
  }
  chooseLanguage(isArabic: boolean) {
    this.modalRef.hide();
   this.storageService.setSessionStorageData('isArabic',isArabic);
   this.isChecker = this.storageService.getSessionStorageData('isChecker');
   if(this.isChecker) {
    this.route.navigate(['executor-dashboard/progress-tracker']);
   } else {
    this.route.navigate(['executor-dashboard/assessment']);
   }
    
  }


}
